const Icon = ({ name, children, className, onClick, stroke = 'currentColor', strokeWidth = 2 }) => {
	return (
		<svg
			fill="none"
			viewBox="0 0 24 24"
			role="presentation"
			stroke={stroke}
			aria-labelledby={name}
			strokeWidth={strokeWidth}
			onClick={() => onClick && onClick()}
			className={className}
		>
			<title id="name" lang="en">{name} icon</title>
			{children}
		</svg>
	)
}

export default Icon